/**
 * Converts bag products to a PreviewOrderRequest for the checkout API
 * @param bagProducts - Array of products from the bag store
 * @param paymentMethodId - Selected payment method ID
 * @returns PreviewOrderRequest object
 * @throws Error if bagProducts is empty, null, or contains more than one product
 */
export const createPreviewOrderRequest = (bagProducts, paymentMethodId) => {
    if (!bagProducts || bagProducts.length === 0) {
        throw new Error('Cannot preview order: bag is empty.');
    }
    else if (bagProducts.length > 1) {
        throw new Error('Cannot preview order: bag contains more than one product.');
    }
    const bagProduct = bagProducts[0];
    const product = {
        products: [
            {
                asin: bagProduct.asin,
                quantity: bagProduct.quantity,
                offerDetails: {
                    offerId: bagProduct.offerId,
                    merchantId: bagProduct.merchantId,
                    selectedOfferId: bagProduct.selectedOfferId,
                },
            },
        ],
    };
    if (paymentMethodId) {
        product.paymentMethodId = paymentMethodId;
    }
    return product;
};
